import { Action, bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";

import { StateType } from "../../../../utils/types";
import {
  deleteNewsFeed,
  getCourse,
  getLearnerNewsFeed,
} from "../../../../redux/learner/actions";
import {
  selectCourses,
  selectCoursesLoaded,
  selectCoursesLoading,
  selectLearnerCoursesNewsFeed,
} from "../../../../redux/learner/selector";

const mapStateToProps = (state: StateType) => ({
  courses: selectCourses(state),
  coursesNewsFeed: selectLearnerCoursesNewsFeed(state),
  loading: selectCoursesLoading(state),
  loaded: selectCoursesLoaded(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators(
    {
      getCourse,
      getLearnerNewsFeed,
      deleteNewsFeed,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
